export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["FolderCreation"] = "Folder Creation";
  return Feature;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["Homepage"] = "Homepage";
  Page["SavingsHomepage"] = "Savings Homepage";
  Page["OrganizeMoney"] = "Organize Money";
  Page["VerifyPhone"] = "Verify Phone";
  Page["CreateFolder"] = "Create Folder";
  Page["ChooseContribution"] = "Choose Contribution";
  Page["ApplyLocation"] = "Apply Location";
  Page["SetGoal"] = "Set Goal";
  Page["ConfirmNewFolder"] = "Confirm New Folder";
  Page["SalesTaxSettings"] = "Sales Tax Settings";
  return Page;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["GetStarted"] = "Get Started";
  Target["Next"] = "Next";
  Target["SendCode"] = "Send Code";
  Target["Verify"] = "Verify";
  Target["SetContribution"] = "Set Contribution";
  Target["Skip"] = "Skip";
  Target["SetGoal"] = "Set Goal";
  Target["LooksGood"] = "Looks Good";
  Target["SalesTaxCard"] = "Sales Tax Card";
  Target["SalesTaxConfirm"] = "Sales Tax Confirm";
  return Target;
}({});
export let MerchantType = /*#__PURE__*/function (MerchantType) {
  MerchantType["MultiUnit"] = "multi_unit";
  MerchantType["SingleUnit"] = "single_unit";
  return MerchantType;
}({});
export let FolderName = /*#__PURE__*/function (FolderName) {
  FolderName["Taxes"] = "Taxes";
  FolderName["RainyDay"] = "Rainy_Day";
  FolderName["Rent"] = "Rent";
  FolderName["Payroll"] = "Payroll";
  FolderName["Custom"] = "Custom";
  FolderName["Expense"] = "Expense";
  FolderName["Retirement"] = "Retirement";
  FolderName["Profit"] = "Profit";
  FolderName["VehicleGas"] = "Vehicle_Gas";
  FolderName["Giving"] = "Giving";
  FolderName["Education"] = "Education";
  return FolderName;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
export function getEvent(action, args) {
  const feature = Feature.FolderCreation;
  return {
    name: getEventName(action, feature),
    properties: {
      feature,
      applet: 'Banking',
      ...args
    }
  };
}